import { BetslipError } from '../betslip-error';

export class MinSelectionsBetbuilderError extends BetslipError {
    constructor() {
        super();
        this.hasClientValidation = true;
    }
}
